var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { Product as ProductProto } from '@square/dashboard-protos/models/squareup/connect/v2/common/source_application';
export const SOURCE_APPLICATION_NAME = {
  CHANNELS: 'Channels',
  WEEBLY: 'Weebly Sync',
  SQUARE_ONLINE_STORE: 'Square Online Store'
};
export let Product = /*#__PURE__*/function (Product) {
  Product["SQUARE_POS"] = "SQUARE_POS";
  Product["EXTERNAL_API"] = "EXTERNAL_API";
  Product["BILLING"] = "BILLING";
  Product["APPOINTMENTS"] = "APPOINTMENTS";
  Product["INVOICES"] = "INVOICES";
  Product["ONLINE_STORE"] = "ONLINE_STORE";
  Product["PAYROLL"] = "PAYROLL";
  Product["OTHER"] = "OTHER";
  Product["DASHBOARD"] = "DASHBOARD";
  Product["ITEM_LIBRARY_IMPORT"] = "ITEM_LIBRARY_IMPORT";
  return Product;
}({});
let SourceApplication = (_dec = attr('string', {
  protoEnum: ProductProto
}), _dec2 = attr('string'), _dec3 = attr('string'), _class = (_class2 = class SourceApplication extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "product", _descriptor, this);
    _initializerDefineProperty(this, "applicationId", _descriptor2, this);
    _initializerDefineProperty(this, "name", _descriptor3, this);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/custom-attribute-definition/source-application'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "product", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "applicationId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { SourceApplication as default };